__turbopack_context__.v({
  "root": "_4-vxxq_root",
  "rootactive": "_4-vxxq_rootactive",
  "sliderNavigationBullet": "_4-vxxq_sliderNavigationBullet",
  "sliderNavigationBulletactive": "_4-vxxq_sliderNavigationBulletactive",
});
